import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CacheBustingInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Add cache busting headers for API requests, but exclude bulk-requirements endpoint
    // to avoid CORS issues with local development server
    if (
      request.url.includes('/api/') &&
      !request.url.includes('/users/bulk-requirements')
    ) {
      const modifiedRequest = request.clone({
        setHeaders: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });
      return next.handle(modifiedRequest);
    }

    return next.handle(request);
  }
}
